import * as React from "react";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { useTheme } from "../../helpers/theme-provider/use-theme.mjs";
import { DiilLogo } from "./diil-logo.mjs";
import { GreenITLogo } from "./greenit-logo.mjs";
import { SuperLogo } from "./super-logo.mjs";
import { TeliaLogo } from "./telia-logo.mjs";
import { TeliaTVLogo } from "./telia-tv-logo.mjs";
const Logo = (props) => {
  const { theme, color, className, size, text, url, target, onClick, brand: propBrand } = props;
  const { brand: themeBrand } = useTheme();
  const brand = propBrand != null ? propBrand : themeBrand;
  const BEM = () => {
    const classArray = ["logo", "logo--".concat(brand)];
    if (color) {
      classArray.push("logo--color-".concat(color));
    }
    if (size) {
      classArray.push("logo--".concat(size));
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const logo = React.useMemo(() => {
    switch (brand) {
      case "super":
        return /* @__PURE__ */ React.createElement(SuperLogo, { className: "logo__img", title: text });
      case "diil":
        return /* @__PURE__ */ React.createElement(DiilLogo, { className: "logo__img", title: text });
      case "greenit":
        return /* @__PURE__ */ React.createElement(GreenITLogo, { className: "logo__img", title: text });
      case "telia-tv":
        return /* @__PURE__ */ React.createElement(TeliaTVLogo, { className: "logo__img", title: text });
      case "telia":
      default:
        return /* @__PURE__ */ React.createElement(TeliaLogo, { className: "logo__img", title: text });
    }
  }, [text, brand]);
  return /* @__PURE__ */ React.createElement("span", { className: BEM(), "data-theme": theme }, url ? /* @__PURE__ */ React.createElement(Anchor, { url, className: "logo__img", onClick, target }, logo) : logo);
};
export {
  Logo
};
